import React from 'react';
import { FaCircleInfo, FaTriangleExclamation } from 'react-icons/fa6';

import styles from './AlertMessage.module.css';

const AlertMessage = ({ type = 'info', text }) => {
  const isWarning = type === 'warning';

  return (
    <div className={`${styles.alert} ${isWarning ? styles.warning : styles.info}`}>
      <div className={styles.iconContainer}>
        {isWarning ? (
          <FaTriangleExclamation className={styles.icon} />
        ) : (
          <FaCircleInfo className={styles.icon} />
        )}
      </div>

      <div className={styles.content}>
        <div className={styles.title}>
          {isWarning ? 'Aviso' : 'Información'}
        </div>
        <div className={styles.text}>{text}</div>
      </div>
    </div>
  );
};

export const WarningMessage = ({ text }) => (
  <AlertMessage type="warning" text={text} />
);

export const InfoMessage = ({ text }) => (
  <AlertMessage type="info" text={text} />
);